import React from 'react';

const DataListQna = (props) => {
  const handleClick = (id) => {
    props.handleListClick(id);
  }

  return (
    <li className="list-admin DataListQna" onClick={() => handleClick(props.data.id)}>
        <div className="wrap-text">
          <div className="wrap-title">
            <p className="adminList-title">{props.data.title}</p>
            <p className={`isAnswer ${!!props.data.comment[0]?`true`: `false`}`}>{!!props.data.comment[0] ? `답변됨` : `답변안됨`}</p>
          </div>
          <ul className="wrap-info">
            {Object.keys(props.data).map(el => {
              if(el ===`id` || el === `images` || el === `timestamp`|| el === `title` || el === "files" || el ==="comment"){
                return "";
              }else{
                return  <li className="info" key = {el}>
                          <p className="info-header">{el}</p>
                          <p className={`info-contents data-${el} ${el==='category' ? `color-main`: ``}`}>{props.data[el]}</p>
                        </li>
              }
            })
          }
          </ul>
        </div>

    </li>
  );
}

export default DataListQna;